import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

export function GenericAreaChart({title, areachartdata1, areachartdata2, areachartlabels, 
    dataset1_label, dataset2_label}: any) {

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom' as const,
          },
          title: {
            display: true,
            text: title,
          },
        },
      };
    
    const labels = areachartlabels;
    const areadata1 = areachartdata1;
    const areadata2 = areachartdata2;

    const data = {
        labels,
        datasets: [
          {
            fill: true,
            label: dataset1_label,
            data: areadata1,
            borderColor: 'rgb(53, 162, 235)',
            backgroundColor: 'rgba(53, 162, 235, 0.5)',
            borderWidth: 1,
          },
          {
            fill: true,
            label: dataset2_label,
            data: areadata2,
            borderColor: 'rgb(53, 162, 162)',
            backgroundColor: 'rgba(53, 162, 162, 0.5)',
            borderWidth: 1,
          },
        ],
      };

    return <Line options={options} data={data} />;
}
